import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './PrivacySection.module.css';
import { FaArrowLeft } from 'react-icons/fa';

const PrivacySection = () => {
  const navigate = useNavigate();

  const { t, i18n } = useTranslation();

  const paragraphs = t('privacy.paragraphs', {
    returnObjects: true,
  });

  console.log(i18n.language);

  return (
    <section className={styles.privacySection}>
      <div className={styles.container}>
        <button
          className={styles.backButton}
          onClick={() => navigate('/')}
        >
          <FaArrowLeft className={styles.icon} />
          {t('privacy.back')}
        </button>

        <h1 className={styles.title}>
          {t('privacy.title')}
        </h1>

        <div className={styles.content}>
          {Array.isArray(paragraphs) &&
            paragraphs.map((text, index) => (
              <p key={index} className={styles.paragraph}>
                {text}
              </p>
            ))}
        </div>
      </div>
    </section>
  );
};

export default PrivacySection;